import React from "react";
import SidebarAdmin from "./SidebarAdmin";
import CardAdmin from "./CardAdmin";
import OrdersCard from "./OrdersCard";
import "../pages/Styles/Admin.css";

const AdminLayout = ({ title, stats = "default", children }) => {
  return (
    <div className="admin-shell">
      <SidebarAdmin />
      <main className="admin-content">
        {title && <h1 className="admin-page-title">{title}</h1>}
        {stats === "default" && (
          <div className="admin-stats-row">
            <CardAdmin />
          </div>
        )}
        {stats === "orders" && (
          <div className="admin-stats-row">
            <OrdersCard />
          </div>
        )}
        <div className="admin-panel">{children}</div>
      </main>
    </div>
  );
};

export default AdminLayout;
